import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { useSelector, useDispatch } from 'react-redux';
import './Navbar.css';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Badge from 'react-bootstrap/Badge';
import Searchbar from './Navbar/Searchbar';
import UserDropdown from './Navbar/UserDropdown';
import { FaHome, FaHubspot, FaShoppingCart, FaUserAlt } from 'react-icons/fa';
import { RootState, store } from '../../config/store';
import RegisterModal from '../../components/RegisterModal';
import LoginModal from '../../components/LoginModal';
import {
  showLoginModal,
  showRegisterModal,
  showConfirmationModal,
} from '../../actions/ui';
import { AuthState } from '../../reducers/auth';
import Text from '../../components/Text';
import AddAddressModal from '../../components/AddAddressModal';
import ConfirmationModal from '../../components/ConfirmationModal';
import clsx from 'clsx';
import { MdAddShoppingCart, MdSearch, MdSecurity } from 'react-icons/md';
import { RiLogoutBoxLine, RiMessengerLine, RiMailLine, RiRefund2Line, RiShareForwardBoxLine, RiZoomInLine } from 'react-icons/ri';
import Row from 'react-bootstrap/Row';
import { IoMdContact, IoMdSearch } from 'react-icons/io'
import { AiOutlineWhatsApp, AiFillCloseCircle, AiFillCompass, AiOutlineCloseCircle, AiFillInfoCircle, AiOutlineClose } from 'react-icons/ai';
import { getToasts } from '../../services/ProfileService';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import { RouteProps, useLocation } from 'react-router';
import { FiChevronRight, FiMenu, FiUserPlus } from "react-icons/fi";
import { Category } from '../../types';
import { getAllCategories } from '../../services/ApiService';
import { track } from '../../services/mixpanelService';
import { BsCardChecklist, BsChevronDown } from 'react-icons/bs';
import BackgroundImage from '../../components/BackgroundImage';
import { Button } from 'react-bootstrap';
import NavBarMostProduct from '../../components/NavBarMostProduct';
import NavBarTrendingProduct from '../../components/NavBarTrendingProduct';
import { dataService } from '../../services/sharedDataService';
import ContinueRegisterModal from '../../components/ContinueRegisterModal';
import ContinueShoppingModal from '../../components/ContinueShoppingModal';
import LinkButton from '../../components/LinkButton';
import ContinueGuestCheckoutModal from '../../components/ContinueGuestCheckoutModal';

export interface NavbarProps {
  history?: any;
  breadCrumb?: { "label": string }[];
}

const Navbar: React.FC<NavbarProps> = ({ history, breadCrumb = [] }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [navCategories, setNavCategories] = useState<Category[]>([]);
  const [viewSideBar, setViewSideBar] = useState<number>(0);
  const [viewMobileInputSearch, setViewMobileInputSearch] = useState<number>(0);
  const inputRef = useRef<HTMLInputElement>(null);


  const location = useLocation();
  let searchKeyVar = ""
  let genderVar = ""
  let categoryIdVar = "";
  if (history?.location?.search != "" && history?.location?.search != null) {
    if (history.location.search.indexOf("searchKey=") != -1) {
      var string = history.location.search,
        preString = "searchKey=",
        searchString = "&",
        preIndex = string.indexOf(preString),
        searchIndex = preIndex + string.substring(preIndex).indexOf(searchString);
      if (preIndex != -1) {
        if (searchIndex == preIndex) {
          searchIndex = string.length
        }
        searchKeyVar = history.location.search.substring(history.location.search.indexOf("searchKey=") + 10, searchIndex)
        searchKeyVar = decodeURIComponent(searchKeyVar)
      }

    }
    genderVar = ""
    if (history.location.search.indexOf("gender=") != -1) {
      var string = history.location.search,
        preString = "gender=",
        searchString = "&",
        preIndex = string.indexOf(preString),
        searchIndex = preIndex + string.substring(preIndex).indexOf(searchString);
      if (searchIndex == preIndex - 1) {
        searchIndex = string.length
      }
      genderVar = history.location.search.substring(history.location.search.indexOf("gender=") + 7, searchIndex)
    }

    categoryIdVar = ""
    if (history.location.search.indexOf("categoryId=") != -1) {
      var string = history.location.search,
        preString = "categoryId=",
        searchString = "&",
        preIndex = string.indexOf(preString),
        searchIndex = preIndex + string.substring(preIndex).indexOf(searchString);
      if (searchIndex == preIndex - 1) {
        searchIndex = string.length
      }
      categoryIdVar = history.location.search.substring(history.location.search.indexOf("categoryId=") + 11, searchIndex)
    }

  }
  const classes = useStyles();

  const { isAuthenticated, user } = useSelector<RootState, AuthState>(
    (state) => state.auth,
  );
  const [searchKey, setSearchKey] = useState(searchKeyVar);
  const [gender, setGender] = useState(genderVar);
  const [categoryId, setCategoryId] = useState(categoryIdVar);
  const [showSideBarCategories, setShowSideBarCategories] = useState<boolean>(false);
  const [showNavMenuCategories, setShowNavMenuCategories] = useState<boolean>(false);


  const searchKeyRef = useRef(searchKey);
  searchKeyRef.current = searchKey;



  const [notify, setNotify] = useState(dataService.getData("viewToast"));
  const [mobileToast, setMobileToast] = useState(false);
  const [linkApp, setLinkApp] = useState("");

  const [toasts, setToasts] = useState()
  const cartItemsCount = useSelector<RootState, number>(
    (state) => state.cart.length,
  );

  useEffect(() => {
    (async () => {
      setSearchKey(searchKeyVar)
    })()
  }, [searchKeyVar]);

  useEffect(() => {
    (async () => {
      setGender(genderVar)
    })()
  }, [genderVar])

  useEffect(() => {
    (async () => {
      setCategoryId(categoryIdVar)
    })()
  }, [categoryIdVar])

  const handleChangeSearchKey = useCallback((value) => {
    setSearchKey(value)
  }, [searchKey]);

  const viewMenuCategories = useCallback((location: string) => {
    location == "sideBar" ? setShowSideBarCategories(true) : setShowNavMenuCategories(true)
  }, [showSideBarCategories, showNavMenuCategories]);

  const hiddenMenuCategories = useCallback((location: string) => {
    location == "sideBar" ? setShowSideBarCategories(false) : setShowNavMenuCategories(false)

  }, [showSideBarCategories, showNavMenuCategories]);



  const handleSubmitSearchKey = useCallback((e) => {
    if (e.key === 'Enter') {
      track("search")
      let allParam = history.location.search.substring(history.location.search.indexOf("&"))
      history.push('/search?searchKey=' + e.target.value + "&" + allParam)
    }
  }, [searchKey]);

  const dispatch = useDispatch();
  const [navHeight, setNavHeight] = useState("0px");
  let categoryPayload = useSelector<RootState, Category[]>((state) => state.categories);
  useEffect(() => {
    (async () => {
      let tempNavCategory: Category[] = [];
      setCategories(categoryPayload);
      categoryPayload.forEach((element: any) => {
        if (element.isNav) {
          tempNavCategory.push(element);
        }
      });
      setNavCategories(tempNavCategory);
      let elements = document.getElementById("allCategories")
      if (elements) {
        setNavHeight(elements.clientHeight + "px")
      }
      if (window.innerWidth <= 760 && dataService.getData("viewMobileToast")) {
        var uagent = navigator.userAgent.toLowerCase();
        if (uagent.search("iphone") > -1 || uagent.search("android") > -1) {
          setLinkApp("https://twigbig.com/app")
          setMobileToast(true)
        }
      }
    })()
  }, [categoryPayload])

  useEffect(() => {
    (async () => {
      try {
        let tempToast = await getToasts();
        if (tempToast && tempToast[0])
          setToasts(tempToast[0].content);
      } catch (e) {
      }
    })();
  }, [dispatch]);

  const useShowLoginModal = useCallback((isFromBurger = false) => {
    setViewSideBar(1)
    if (isFromBurger)
      track("burger_login")
    dispatch(showLoginModal());
  }, [dispatch]);

  const openSideBar = useCallback(() => {
    setViewSideBar(2)
    track("open_burger")
  }, [dispatch]);



  const openMobileInput = useCallback(() => {
    setViewMobileInputSearch(2);

    if (inputRef?.current != null) {
      inputRef.current.focus();
    }
  }, [inputRef]);


  const useShowConfirmationModal = useCallback(() => {
    setViewSideBar(1)
    dispatch(showConfirmationModal());
  }, [dispatch]);

  const useShowRegisterModal = useCallback(() => {
    dispatch(showRegisterModal());
  }, [dispatch]);


  const taggleNotify = useCallback(() => {
    if (notify) {
      setNotify(false);
      dataService.setData("viewToast", false);
    } else {
      setNotify(true);
      dataService.setData("viewToast", true);
    }
  }, [notify]);


  const closeMobileNotify = useCallback(() => {
    setMobileToast(false);
    dataService.setData("viewMobileToast", false);
  }, []);



  const goToLink = useCallback((e, type, link?, genderValue?) => {

    e.preventDefault();
    if (viewSideBar == 2)
      setViewSideBar(1)
    if (type == "discover" && location.pathname != "/discover") {
      history.push("/discover")
    } else if (type == "profile") {
      if (user == null) {
        dispatch(showRegisterModal());
      } else if (location.pathname != "/" + user.username)
        history.push(user.username)
    } else if (type == "offer") {
      history.push("/search?searchKey=&tab=offers")
    }
    else if (type == "offerSideBar") {
      history.push("/search?searchKey=&tab=offers")
      track("offers_burger");
      track("view_item_list")
    }
    else if (type == "category") {
      history.push(link)
      // track("category-Discover")
    }


    else if (type == "categorySideBar") {
      history.push(link)
      track("category_burger_menu")
    }
    else if (type == "gender") {
      var res = link
      if (history.location.search.indexOf("gender=") != -1) {
        var string = history.location.search,
          preString = "gender=",
          searchString = "&",
          preIndex = string.indexOf(preString),
          searchIndex = preIndex + string.substring(preIndex).indexOf(searchString);
        if (searchIndex == preIndex - 1) {
          searchIndex = string.length
        }
        var genderVar = history.location.search.substring(history.location.search.indexOf("gender=") + 7, searchIndex)
        var res = string.replace(genderVar, genderValue);
      }
      history.push(res)
      track("category_burger_menu")
      setGender(genderValue)
    } else {
      setTimeout(() => {
        history.push(link)
      }, 1000);
    }
  }, [dispatch, location, history, viewSideBar]);

  // const goToDiscover = useCallback((value) => {
  //   if (location.pathname != "/discover")
  //     history.push("/discover")
  // }, [dispatch, location]);


  // const goToProfile = useCallback((value) => {
  //   if (user == null) {
  //     dispatch(showRegisterModal());
  //   } else if (location.pathname != "/" + user.username)
  //     history.push(user.username)
  // }, [dispatch, location]);


  return (
    <>

      {
        mobileToast ?
          <Row>
            <Col xs={12} className={classes.donwnloadApp}>
              {/* Dowanload the App from  <a href={linkApp} target="_blank">here</a> */}
              <BackgroundImage
                className={classes.bannerIcon}
                height="45px"
                width="45px"
                borderRadius="5px"
                src={`${process.env.PUBLIC_URL}/assets/img/main-logo.jpg`}
              ></BackgroundImage>
              <LinkButton href={linkApp}>Get the app</LinkButton>
              <AiOutlineCloseCircle onClick={closeMobileNotify} className={classes.closeIcon} />

            </Col>
          </Row>
          : null
      }
      {
        notify && toasts ?
          <Row >
            <Col xs={12} className={classes.freeDeleviery}>
              <p className={classes.toasts}>{toasts}</p>
              <AiOutlineCloseCircle onClick={taggleNotify} className={classes.closeIcon} />
            </Col>
          </Row>
          : null
      }
      <div onClick={e => setViewSideBar(1)} className={clsx(classes.sideBar, viewSideBar == 2 ? classes.viewSideBar : null)}>
      </div>
      <div className={clsx(classes.mainSideBar, viewSideBar == 2 ? classes.viewMainSideBar : viewSideBar == 1 ? classes.hideMainSideBar : null)}>
        {
          isAuthenticated ?
            <div className={classes.userInfo}>
              <BackgroundImage
                height="60px"
                width="60px"
                resizeMode="cover"
                className={classes.imgProfile}
                src={user ? user.avatarUrl : ""}
              ></BackgroundImage>
              <Link to={user ? user.username : ""}>
                <Text bold className={classes.username}>
                  {user ? user.name : ""}
                </Text>
              </Link>

              {
                user && user.businesses ?
                  <Link to={user ? user.username : ""}>
                    <Text bold className={classes.businessName}>
                      {user && user.businesses[0] ? user.businesses[0].name : ""}
                    </Text>
                  </Link>
                  : null
              }

              {/* </div> */}
            </div>
            : null
        }
        <div className={classes.spreaterSideBar}></div>
        <div className={classes.itemSideBar} >
          <a href="/search?searchKey=&tab=offers" className={classes.textItemSideBar} onClick={e => goToLink(e, "offerSideBar")}>
            <Text bold className={classes.titleTextItemSideBar}>Offers</Text>
          </a>
        </div>
        <div className={classes.spreaterSideBar}></div>



        <div className={classes.itemSideBar}>
          <a href="search?searchKey=&gender=male" className={classes.textItemSideBar} onClick={e => goToLink(e, "gender", "search?searchKey=&gender=male", "male")}>
            <Text className={classes.titleTextItemSideBar} bold>Men</Text></a>
          <a href="search?searchKey=&gender=female" className={classes.textItemSideBar} onClick={e => goToLink(e, "gender", "search?searchKey=&gender=female", "female")}>
            <Text className={classes.titleTextItemSideBar} bold>Women</Text></a>
          {/* <div className={classes.textItemSideBar} onClick={e => goToLink("gender", "search?searchKey=&gender=Kids", "Kids")}>
            <Text className={classes.titleTextItemSideBar} bold>Kids</Text></div> */}
        </div>
        <div className={classes.spreaterSideBar}></div>

        <div className={classes.itemSideBar}>
          <div className={classes.textItemSideBar}><Text bold className={classes.titleTextItemSideBar} >Category By</Text></div>
        </div>
        <div className={classes.spreaterSideBar}></div>


        {
          // categories.map((category) =>
          categories.map((category) =>
            <div key={category.id} className={classes.itemSideBar}>
              <a href={"/search?searchKey=&categoryId=" + category.id} className={classes.textItemSideBar} onClick={e => { goToLink(e, "categorySideBar", "/search?searchKey=&categoryId=" + category.id) }}>
                <BackgroundImage width="15px" className={classes.imageTextItemSideBar} height="15px" resizeMode="cover" src={category.photo}></BackgroundImage>
                <Text className={classes.titleTextItemSideBar}>{category.name}</Text>
              </a>
            </div>
          )
          //   <div style={{ flex: "1 1 20" }} key={category.id}>{category.name}</div>
          // )
        }

        <div className={classes.spreaterSideBar}></div>
        <div className={classes.itemSideBar} >
          <a href="register" className={classes.textItemSideBar} onClick={e => goToLink(e, "static", "register")}>
            <FaShoppingCart style={{ marginTop: "2px", marginLeft: "-8px", color: "white" }}></FaShoppingCart>
            <div className={classes.textItemSideBar}>
              <Text bold className={classes.titleTextItemSideBar}>Become a Seller</Text></div>

          </a>
        </div>
        <div className={classes.spreaterSideBar}></div>
        <div className={classes.itemSideBar} >
          <a href="creator" className={classes.textItemSideBar} onClick={e => goToLink(e, "static", "creator")}>
            <FiUserPlus style={{ marginTop: "2px", marginLeft: "-8px", color: "white" }}></FiUserPlus>
            <div className={classes.textItemSideBar}>
              <Text bold className={classes.titleTextItemSideBar}>Become a Creator</Text></div>

          </a>
        </div>


        <div className={classes.spreaterSideBar}></div>
        {isAuthenticated ?
          <div onClick={useShowConfirmationModal} className={classes.itemSideBar}>
            <AiFillInfoCircle style={{ marginTop: "4px", color: "white" }}></AiFillInfoCircle>
            <div className={classes.textItemSideBar}><Text bold className={classes.titleTextItemSideBar}>Logout</Text></div>
          </div> :
          <div onClick={useShowLoginModal} className={classes.itemSideBar}>
            <AiFillInfoCircle style={{ marginTop: "4px", color: "white" }}></AiFillInfoCircle>
            <div className={classes.textItemSideBar}><Text bold className={classes.titleTextItemSideBar}>LogIn</Text></div>
          </div>
        }
        <div className={classes.spreaterSideBar}></div>


        <a href="terms-and-conditions" onClick={e => goToLink(e, "static", "terms-and-conditions")} className={classes.itemSideBar}>
          <BsCardChecklist style={{ marginTop: "4px", color: "white" }}></BsCardChecklist>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>Terms & Conditions</Text>
          </div>
        </a>
        <div className={classes.spreaterSideBar}></div>

        <a href="privacy-policy" onClick={e => goToLink(e, "static", "privacy-policy")} className={classes.itemSideBar}>
          <MdSecurity style={{ marginTop: "4px", color: "white" }}></MdSecurity>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>Privacy Policy</Text>
          </div>
        </a>
        <div className={classes.spreaterSideBar}></div>

        <a href="refund-and-cancellation-policy" onClick={e => goToLink(e, "static", "refund-and-cancellation-policy")} className={classes.itemSideBar}>
          <RiRefund2Line style={{ marginTop: "4px", color: "white" }}></RiRefund2Line>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>Refund and Cancellation policy</Text>
          </div>
        </a>
        <div className={classes.spreaterSideBar}></div>

        <a href="shipping-and-return-policy" onClick={e => goToLink(e, "static", "shipping-and-return-policy")} className={classes.itemSideBar}>
          <RiShareForwardBoxLine style={{ marginTop: "4px", color: "white" }}></RiShareForwardBoxLine>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>Shipping and Return Policy</Text>
          </div>
        </a>
        <div className={classes.spreaterSideBar}></div>

        <a href="about-us" onClick={e => goToLink(e, "static", "about-us")} className={classes.itemSideBar}>
          <RiZoomInLine style={{ marginTop: "4px", color: "white" }}></RiZoomInLine>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>About Us</Text>
          </div>
        </a>
        <div className={classes.spreaterSideBar}></div>


        <a href="contact-us" onClick={e => goToLink(e, "static", "contact-us")} className={classes.itemSideBar}>
          <IoMdContact style={{ marginTop: "4px", color: "white" }}></IoMdContact>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>Contact Us</Text>
          </div>
        </a>
        <div className={classes.spreaterSideBar}></div>


        <div className={classes.itemSideBar}>
          <div className={classes.textItemSideBar}>
            <Text bold className={classes.titleTextItemSideBar}>Returns & Support</Text>
          </div>
        </div>
        <div style={{ flexDirection: "row-reverse" }} className={classes.itemSideBar}>
          <div className={classes.textItemSideBar}>
            <a onClick={e => track("refund", { "support_type": "Messenger" })} target="_blank" href="https://m.me/twigBIG" className={classes.iconTextItemSideBar}>
              <RiMessengerLine></RiMessengerLine>
            </a>
            <a onClick={e => track("refund", { "support_type": "WhatsApp" })} target="_blank" className={classes.iconTextItemSideBar} href="https://api.whatsapp.com/send?phone=+971559696662">
              <AiOutlineWhatsApp></AiOutlineWhatsApp>
            </a>

            <a onClick={e => track("refund", { "support_type": "Email" })} href="mailto:support@twigbig.com" className={classes.iconTextItemSideBar}>
              <RiMailLine></RiMailLine>
            </a>

            <a onClick={e => track("refund", { "support_type": "Hsforms" })} target="_blank" href="https://share.hsforms.com/16m2pKgpMQiaRYuDtBA_FXQ4mjyw" className={classes.iconTextItemSideBar}>
              <FaHubspot></FaHubspot>
            </a>


          </div>
        </div>

        <div className={classes.spreaterSideBar}></div>



      </div>
      <div className={classes.mobileNav}>
        <FiMenu style={{ fontSize: "28px", color: "#522583" }} onClick={e => openSideBar()}></FiMenu>
        <Link to="/">
          <img
            alt="twigbig"
            width="137px"
            src={`${process.env.PUBLIC_URL}/assets/img/twigLogo.svg`}
          />
        </Link>
        <div className={classes.mobileSearch}>
          <div style={{ width: "28px", height: "28px" }}>
            {
              viewMobileInputSearch != 2 ?
                <IoMdSearch onClick={openMobileInput} className={viewMobileInputSearch == 1 ? classes.openSearchBar : ""} style={{ fontSize: "28px", color: "#522583" }}></IoMdSearch>
                : null
            }
          </div>

          <input value={searchKey}
            ref={inputRef}
            onChange={e => handleChangeSearchKey(e.target.value)}
            onKeyDown={e => handleSubmitSearchKey(e)}
            className={clsx(classes.mobileInputSearch, viewMobileInputSearch == 2 ? classes.viewMobileInputSearch : viewMobileInputSearch == 1 ? classes.hideMobileInputSearch : "")}></input>
          {
            viewMobileInputSearch == 2 ?
              <AiOutlineClose onClick={e => setViewMobileInputSearch(1)} className={classes.closeSearchBar}></AiOutlineClose>
              : null
          }

        </div>
        <Nav.Link onClick={useShowRegisterModal} className={clsx(classes.navBar, classes.navBarBubble)}>Register</Nav.Link>

      </div>
      <div className={classes.header}>
        <BootstrapNavbar className={classes.mainNav} variant="dark">
          <RegisterModal />
          <ContinueRegisterModal />
          <ContinueShoppingModal />
          <ContinueGuestCheckoutModal />
          <LoginModal />
          <ConfirmationModal />
          <AddAddressModal />
          <div>
            <BootstrapNavbar.Brand className="">
              <FiMenu style={{ marginRight: "18px", fontSize: "25px" }} onClick={e => openSideBar()}></FiMenu>
              {/* <div>hi</div> */}
              <Link to="/">
                <img
                  width="137px"
                  src={`${process.env.PUBLIC_URL}/assets/img/twigLogoWhite.svg`}
                  // src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
                  alt="TwigBig"
                />
              </Link>
            </BootstrapNavbar.Brand>
          </div>

          <div className={classes.devSearch}>
            <input type="text" className={classes.inputSearch}
              name="item"
              placeholder="Search"
              value={searchKey}
              onChange={e => handleChangeSearchKey(e.target.value)}
              onKeyDown={e => handleSubmitSearchKey(e)}
            />
            <MdSearch className={classes.inputSearchIcon} />
          </div>
          {/* <BootstrapNavbar.Collapse
          className="collapsible-content"
          id="collapsible-content"
        > */}
          <div className={classes.web}>

            {!isAuthenticated ? (
              <>
                <Nav className="">
                  <div className="mr-4 pt-2">
                    <Link className={classes.iconLink} to="/cart">
                      <FaShoppingCart />
                      <Badge className={classes.badge}>{cartItemsCount}</Badge>
                    </Link>
                  </div>
                  <Nav.Link onClick={useShowLoginModal} className={classes.navBar}>Login</Nav.Link>
                  <Nav.Link onClick={useShowRegisterModal} className={clsx(classes.navBar, classes.navBarBubble)}>Register</Nav.Link>
                </Nav>
              </>
            ) : (
              <Nav className="">
                <div className="mr-4">
                  <Link className={classes.iconLink} to="/cart">
                    <FaShoppingCart />
                    <Badge className={classes.badge}>{cartItemsCount}</Badge>
                  </Link>
                </div>
                <div className={classes.web}>
                  <Link className={clsx('mr-4', classes.iconLink)} to="/creator">
                    <img
                      width="25px"
                      src={`${process.env.PUBLIC_URL}/assets/img/becomeACreator.svg`}
                      alt="TwigBig"
                    />
                  </Link>
                  <Link className={clsx('mr-4', classes.iconLink)} to="/register">
                    <img
                      width="20px"
                      src={`${process.env.PUBLIC_URL}/assets/img/becomeASeller-01.svg`}
                      alt="TwigBig"
                    />

                  </Link>

                </div>
                <div className={classes.avatarBox}>
                  <Link to={user ? user.username : ""}>
                    <Image
                      className={classes.avatar}
                      // src={user?.avatarUrl}
                      src={user ? user.avatarUrl : ""}
                      alt={user ? user.name : ""}
                      roundedCircle
                    />
                  </Link>
                </div>
                <NavDropdown title={user?.name} id="basic-nav-dropdown" className={classes.navDropdown}>
                  <NavDropdown.Item onClick={useShowConfirmationModal} href="#action/3.1">Logout</NavDropdown.Item>
                </NavDropdown>

                {/* <div className={clsx("mr-4", classes.mobile)}>
                <div
                  className={classes.iconLink}
                  onClick={useShowConfirmationModal}
                >
                  <RiLogoutBoxLine />
                </div>
              </div>

              <div className={classes.web}>
                <div
                  className={classes.iconLink}
                  onClick={useShowConfirmationModal}
                >
                  <Text as="span" color="white">
                    
                </Text>
                </div>
              </div> */}
              </Nav>
            )
            }

          </div>


          {/* </BootstrapNavbar.Collapse> */}
          {/* <BootstrapNavbar.Collapse
        className="collapsible-content"
        id="collapsible-content"
      >
        <Nav className="mr-auto">
          <Nav.Link href="#home">Home</Nav.Link>
          <Nav.Link href="#link">Link</Nav.Link>
        </Nav>
      </BootstrapNavbar.Collapse>
      <Nav className="mx-lg-3">
        <Searchbar />
      </Nav>
      <Nav className="d-none d-lg-flex actions ml-auto">
        <UserDropdown />
      </Nav> */}
        </BootstrapNavbar >
      </div>
      {/* </div> */}
      {/* <Row>
        <Col className={classes.genderNav} xs={12}>
          <div className={classes.tagFilter} onClick={e => goToLink("gender", "search?searchKey=&gender=Male", "Male")}>
            <Text className={clsx(classes.genderText, gender == "Male" ? classes.genderActive : null)}>Male</Text>
            {gender == "Male" ?
              <div className={classes.circleGenderActive}>
              </div> : null
            }
          </div>

          <div className={classes.tagFilter} onClick={e => goToLink("gender", "search?searchKey=&gender=Female", "Female")}>
            <Text className={clsx(classes.genderText, gender == "Female" ? classes.genderActive : null)}>Female</Text>
            {gender == "Female" ?
              <div className={classes.circleGenderActive}>
              </div> : null
            }

          </div>
        </Col>
      </Row> */}
      <Row className={classes.nav}>
        <Col xs={12} className={classes.subNav}>
          <div className={classes.categoriesTab}>
            <div onMouseOver={e => viewMenuCategories("sideBar")}>
              <Text bold className={classes.categoriesTabText}> All Categories
                <BsChevronDown className={classes.categoriesTabIcon}></BsChevronDown>
              </Text>
            </div>
            <div onMouseLeave={e => hiddenMenuCategories("sideBar")} style={{ display: showSideBarCategories ? "block" : "none" }} id="allCategories" className={classes.allCategories}>
              <Row>
                <Col lg={12}>
                  {
                    categories.map((category) =>
                      <>
                        <div style={{ flex: "1 1 20" }}
                          className={clsx(classes.oneCategoryText)}
                          key={category.id}>
                          <Link to={"search?searchKey=&categoryId=" + category.id} className={classes.tagFilter} onClick={e => { goToLink(e, "category", "/search?searchKey=&categoryId=" + category.id); hiddenMenuCategories("sideBar") }}>
                            {category.name}
                          </Link>
                          <div style={{ height: navHeight }} className={classes.oneCategory}>
                            <Row>
                              {
                                category.brands.length != 0 ?
                                  <Col md={6}>
                                    <Text as="p" bold color="black"> Brand </Text>
                                    {
                                      category.brands.map((brand) =>
                                        <Link key={brand.id} to={"search?searchKey=&brandId=" + brand.id} onClick={e => { goToLink(e, "category", "/search?searchKey=&brandId=" + brand.id); hiddenMenuCategories("sideBar") }}>
                                          <Text className={classes.itemOneCategory} as="p" color="black"> {brand.name} </Text>
                                        </Link>
                                      )}
                                  </Col>
                                  : null
                              }
                              {
                                category.Subcategory.length != 0 ?
                                  <Col md={6}>
                                    <Text as="p" bold color="black"> Sub categories </Text>
                                    {
                                      category.Subcategory.map((subCategory) =>

                                        <Link to={"search?searchKey=&categoryId=" + category.id + "&subcategoryId=" + subCategory.id} onClick={e => { goToLink(e, "category", "/search?searchKey=&categoryId=" + category.id + "&subcategoryId=" + subCategory.id); hiddenMenuCategories("sideBar") }}>
                                          <Text as="p" className={classes.itemOneCategory} color="black"> {subCategory.name} </Text>
                                        </Link>
                                      )}
                                  </Col>
                                  : null
                              }
                            </Row>
                          </div>
                        </div>
                      </>
                    )
                  }
                </Col>
              </Row>
            </div>
          </div>
          <div className={classes.offerTab}>
            {/* <Link to={"search?searchKey=&tab=offers"}> */}
            <Link to={"discover"} className={classes.offerTagFilter} onClick={e => goToLink(e, "discover")}>
              <Text className={classes.offerTabText}> Discover</Text>
            </Link>
            <div className={classes.spreter}></div>
            <Link to={"offers"} className={classes.offerTagFilter} onClick={e => goToLink(e, "offer")}>
              <Text className={classes.offerTabText}> Offers</Text>
            </Link>
            {/* </Link> */}
            <div className={classes.spreter}></div>
            {
              navCategories.map((category) =>
                <div>
                  <a className={clsx(classes.tagFilter, classes.oneCategoryNav)} href={"search?searchKey=&categoryId=" + category.id} onClick={e => { goToLink(e, "category", "/search?searchKey=&categoryId=" + category.id); history.push("/search?searchKey=&categoryId=" + category.id) }}>
                    <Text className={clsx(classes.tagText, categoryId == category.id ? classes.tagActive : null)}>{category.name}</Text>
                    {categoryId == category.id ?
                      <div className={classes.circleGenderActive}>
                      </div> : null
                    }
                  </a>

                  <div className={classes.oneCategoryNavMenu}>
                    <Row>
                      <Col xl={1}></Col>
                      {
                        category.Subcategory.length != 0 ?

                          <Col style={{ marginTop: "20px" }} xl={2}>
                            <Text as="p" bold color="black"> Sub categories </Text>
                            {
                              category.Subcategory.map((subCategory) =>

                                <a href={"/search?searchKey=&categoryId=" + category.id + "&subCategoryId=" + subCategory.id} onClick={e => goToLink(e, "category", "/search?searchKey=&categoryId=" + category.id + "&subCategoryId=" + subCategory.id)}>

                                  <Text className={classes.subcategoryText} as="p" color="black"> {subCategory.name} </Text>
                                </a>
                              )}

                          </Col>
                          : null
                      }

                      {
                        category.brands.length != 0 ?

                          <Col style={{ marginTop: "20px" }} xl={2}>
                            <Text as="p" bold color="black"> Brands </Text>
                            {
                              category.brands.slice(1, 10).map((brand) =>
                                <a href={"/search?searchKey=&brandId=" + brand.id} onClick={e => goToLink(e, "category", "/search?searchKey=&brandId=" + brand.id)}>
                                  <Text className={classes.subcategoryText} as="p" color="black"> {brand.name} </Text>
                                </a>
                              )}
                          </Col>
                          : null
                      }

                      {
                        category.products_trending && category.products_trending.length > 1 ?
                          < Col style={{ marginTop: "20px" }} md={3}>
                            <Text as="p" bold color="black"> Trending Now </Text>
                            <div className={classes.navProducts}>
                              {
                                category.products_trending.slice(1, 6).map((product) =>
                                  <NavBarTrendingProduct product={product}></NavBarTrendingProduct>
                                )
                              }
                            </div>
                          </Col>
                          : null
                      }



                      {
                        category.products_trending && category.products_trending.length > 0 ?

                          <Col md={3}>
                            <Text as="p" bold color="black"> Most Viewed Product </Text>

                            < NavBarMostProduct product={category.products_trending[0]}></NavBarMostProduct>

                          </Col>
                          : null}

                      {/* <div className={classes.mainProduct}>
                          <div className={classes.mainProductImgDiv}>
                            <BackgroundImage className={classes.mainProductImg} src={"https://upload.wikimedia.org/wikipedia/commons/8/8c/Cristiano_Ronaldo_2018.jpg"} height="30px"></BackgroundImage>
                          </div>
                          <div>
                            <Button className={classes.mainProductButton}> Click</Button>
                          </div>
                          <Text as="p" className={classes.mainProductName} bold color="black">Hellllllllo</Text>
                          <div className={classes.mainProductPriceDiv}>
                            <Text className={classes.navProductPrice} bold>250</Text>
                            <Text className={classes.navProductPriceDiscount}>250</Text>
                          </div>
                        </div> */}
                    </Row>
                  </div>
                </div>
              )
            }
          </div>
        </Col>
      </Row>
      {
        breadCrumb.length != 0 ?
          <Row className={classes.breadCrumb}>
            <Col md={12}>
              <ul>
                {
                  breadCrumb.map((item, key) =>
                    <>
                      <li>{item.label}</li>
                      {
                        key + 1 != breadCrumb.length ?
                          <li><FiChevronRight></FiChevronRight></li>
                          : null
                      }
                    </>
                  )
                }
              </ul>
            </Col>
          </Row>
          : null
      }


      <div className={classes.mobileCategory}>
        <div className={clsx(classes.mobileCategoryDev, categoryId == "" ? classes.mobileCategoryDevActive : null)} onClick={e => goToLink(e, "category", "/search?searchKey=")}>

          {/* <Link to={"search?searchKey=&categoryId=" + category.id}> */}
          <Text className={clsx(classes.mobileCategoryDevText, categoryId == "" ? classes.mobileCategoryDevTextActive : null)}>ALL </Text>
          {/* </Link> */}
        </div>
        {

          categories.map((category) =>
            <a href={"search?searchKey=&categoryId=" + category.id} className={clsx(classes.mobileCategoryDev, categoryId == category.id ? classes.mobileCategoryDevActive : null)} onClick={e => goToLink(e, "category", "/search?searchKey=&categoryId=" + category.id)}>

              {/* <Link to={"search?searchKey=&categoryId=" + category.id}> */}
              <Text className={clsx(classes.mobileCategoryDevText, categoryId == category.id ? classes.mobileCategoryDevTextActive : null)}>{category.name}</Text>
              {/* </Link> */}
            </a>
          )
        }
      </div>

      {/* <div className={classes.bottomNavTab}>
          <div className={classes.bottomNavTabHexagon}>
            <Text className={classes.bottomNavTabHexagonPlus}>+</Text>
          </div>
        </div> */}

      <Row className={classes.bottomNav}>

        <div className={classes.bottomNavTab}>
          <Link to="explorer">
            <div className={classes.bottomNavTabDiv}>
              {/* <FaHome></FaHome> */}
              <img alt="explorer" className={classes.bottomNavTabImage} src={location.pathname == '/explorer' ? `${process.env.PUBLIC_URL}/assets/img/ic_home_active.png` : `${process.env.PUBLIC_URL}/assets/img/ic_home.png`}></img>
            </div>
            <Text as="p" className={classes.bottomNavTabText} color="black">Home</Text>
          </Link>
        </div>
        <div className={classes.bottomNavTab} onClick={e => goToLink(e, "discover")}>
          {/* <Link to="discover"> */}
          <div className={classes.bottomNavTabDiv}>
            {/* <FaHome></FaHome> */}
            <img alt="discover" className={classes.bottomNavTabImage} src={location.pathname == '/discover' ? `${process.env.PUBLIC_URL} /assets/img/ic_explore_active.png` : `${process.env.PUBLIC_URL}/assets/img/ic_explore_inactive.png`}></img>
          </div>
          <Text as="p" className={classes.bottomNavTabText} color="black">Discover</Text>
          {/* </Link> */}
        </div>

        <div className={classes.bottomNavTab}>
          <Link to="cart">
            <div className={classes.bottomNavTabDiv}>
              <Badge className={classes.badge}>{cartItemsCount}</Badge>
              <img alt="cart" className={classes.bottomNavTabImage} src={location.pathname == '/cart' ? `${process.env.PUBLIC_URL} /assets/img/ic_cart_active.png` : `${process.env.PUBLIC_URL}/assets/img/ic_cartNav.png`}></img>
            </div>
            <Text as="p" className={classes.bottomNavTabText} color="black">Cart</Text>
          </Link>
        </div>

        <div onClick={e => goToLink(e, "profile")} className={classes.bottomNavTab}>
          <div className={classes.bottomNavTabDiv}>
            <img alt="profile" className={classes.bottomNavTabImage} src={user != null && location.pathname == "/" + user.username ? `${process.env.PUBLIC_URL} /assets/img/ic_profile_active.png` : `${process.env.PUBLIC_URL}/assets/img/ic_profile_inactive.png`}></img>
          </div>
          <Text as="p" className={classes.bottomNavTabText} color="black">Profile</Text>
        </div>
      </Row>

    </>
  );
};

const useStyles = createUseStyles({
  freeDeleviery: {
    backgroundColor: "#522583",
    color: "white",
    position: "relative",
    padding: "10px calc(1rem + 15px)",
    textAlign: "center"
  },
  header: {
    width: '100vw',
    backgroundColor: "#000",
  },
  toasts: {
    color: '#fff',
    fontSize: '17px',
  },
  donwnloadApp: {
    backgroundColor: "white",
    color: "#522583",
    position: "relative",
    padding: "10px calc(1rem + 15px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    paddingLeft: 0,
    "& a": {
      textDecoration: "none",
      color: "white",
      "&:hover": {
        color: "white"
      }
    }
  },
  bannerIcon: {
    marginRight: '60px',
  },
  nav: {
    backgroundColor: "white"
  },
  subNav: {
    display: "inherit",
    borderBottom: "1px solid gray",
    width: '100%',
    maxWidth: '1920px',
    margin: '0 auto',
  },
  offerTab: {
    display: "flex",
    // width: "70%",
    padding: "0px 10px"
  },
  categoriesTab: {
    padding: "0px 1rem",
  },
  "categoriesTabIcon": {
    marginInlineStart: "10px"
  },
  categoriesTabText: {
    padding: "9px 0px",
    width: "fit-content",
    fontSize: "14px",

    "&:hover": {
      cursor: 'pointer'
    },
    // "&:hover + $allCategories": {
    //   visibility: "inherit",
    // }
  },
  allCategories: {
    boxShadow: "0px 4px 10px 0px grey",
    cursor: "default",
    position: "absolute",
    // visibility: "hidden",
    left: "0px",
    top: "40px",
    width: "250px",
    backgroundColor: "white",
    zIndex: "3",
    padding: "10px 0px 20px",
    "&:hover": {
      visibility: "inherit",
    }
  },
  oneCategoryText: {
    // color: "red",
    fontSize: "14px",
    padding: "3px 20px 3px 40px",
    "&:hover": {
      backgroundColor: "#522583"
    },
    "&:hover  $oneCategory": {
      display: "block !important",
    },
    "&:hover  $tagFilter": {
      color: "white !important"
    }

  },
  modalContainer: {

  },
  oneCategory: {
    minHeight: '100%',
    position: "absolute",
    display: "none",
    left: "250px",
    top: "-10px",
    height: '700px',
    boxShadow: "0px 4px 10px 0px grey",
    padding: "5px 25px",
    overflowY: "auto",
    overflowX: "hidden",
    width: "450px",
    backgroundColor: "#fafafa",
    "&::-webkit-scrollbar": {
      width: "6px"
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1"
    },
    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#585858",
      borderRadius: "5px"
    },
    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555"
    }

  },
  itemOneCategory: {
    padding: "3px 0px",
    cursor: "pointer"
  },
  offerTabText: {
    padding: "9px 5px",
    fontSize: "14px",
    color: "#522583 !important",
    fontWeight: "bold"
  },

  spreter: {
    width: "1px",
    margin: "13px 3px",
    // boxShadow: "1px 0px 1px #8080804f, 0px 1px 1px #8080804f, -1px 0px 1px #8080804f, 0px -1px 1px #8080804f",
    backgroundColor: "#5d5d5d"
  },
  oneCategoryNav: {
    marginRight: "2px",
    position: "relative",
    "&:hover + $oneCategoryNavMenu": {
      display: "block !important"
    }
  },
  oneCategoryNavMenu: {
    boxShadow: "0px 4px 10px 0px grey",
    position: "absolute",
    top: "40px",
    left: "0px",
    width: "100%",
    backgroundColor: "white",
    display: "none",
    zIndex: "11",
    padding: "10px 40px 10px",
    "&:hover": {
      display: "block !important"
    }
  },
  tagText: {
    padding: "10px 9px",
    width: "fit-content",
    fontSize: "13px",
    fontWeight: "bold"
  },




  bottomNav: {
    position: "fixed",
    "boxShadow": "1px 0px 10px #61616185",
    zIndex: "2",
    bottom: "0px",
    width: "100%",
    height: "60px",
    paddingTop: "8px",
    backgroundColor: "white",
    justifyContent: "space-around",
    display: "none",
    margin: "0px"
  },
  bottomNavTab: {
    // position: "relative"
  },

  bottomNavTabHexagon: {
    width: "30px",
    height: "17.32px;",
    background: "#522583",
    margin: "14.66px 0",
    position: "relative",
    '&:before': {
      content: '""',
      position: "absolute",
      bottom: "100%",
      left: "0px",
      width: "0px",
      height: "0px",
      borderLeft: "15px solid transparent;",
      borderRight: "15px solid transparent;",
      borderBottom: "8.66px solid #522583",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      top: "100%",
      left: "0px",
      width: "0px",
      height: "0px",
      borderLeft: "15px solid transparent;",
      borderRight: "15px solid transparent;",
      borderTop: " 8.66px solid #522583"
    },
  },
  bottomNavTabHexagonPlus: {
    fontSize: "35px",
    color: "white!important",
    position: "absolute",
    top: "-21px",
    left: "2px",
    zIndex: "1000"
  },
  bottomNavTabBadge: {

    top: "2px !important",
    color: "white"
  },
  bottomNavTabDiv: {
    position: "relative",
    textAlign: "center",
    height: "27px",
    marginBottom: "3px"
  },
  bottomNavTabImage: {
    // width: "100%",
    height: "100%",
  },
  bottomNavTabText: {
    textAlign: "center",
    fontSize: "11px"
  },
  closeIcon: {
    fontSize: "20px",
    position: "absolute",
    right: "calc(1rem + 20px)",
    margin: "auto",
    top: "0px",
    bottom: "0px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  link: {
    fontSize: "14px",
    backgroundColor: "white",
    borderRadius: "20px",
    padding: "2px 10px",
    right: "100px",
    color: "black",
    margin: "0px 20px",
    fontWeight: "500",
    "&:hover": {
      cursor: "pointer"
    }
  },
  mobileNav: {
    height: "48px",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    /* justify-items: self-start; */
    padding: "0px 20px",
    position: "relative",
    display: "none",
  },
  mobileSearch: {
  },

  closeSearchBar: {
    position: "absolute",
    right: "20px",
    top: "12px",
    zIndex: "20",
    fontSize: "24px",
    color: "#522583"
  },
  "@keyframes viewZoom": {
    "10%": {
      opacity: "0"

    },
    "100%": {
      opacity: "1"
    }
  },
  openSearchBar: {
    animationName: '$viewZoom',
    animationDuration: "2s",


  },
  mobileInputSearch: {
    position: "absolute",
    width: "0px",
    height: "48px",
    padding: "0px",
    top: "0px",
    right: "34px",
    margin: "0px",
    border: "0px",
    background: "#ccc",
    color: "white",
    fontSize: "22px",
  },
  "@keyframes openInputSearch": {
    from: {
      right: "34px",
      width: "0%",
      paddingLeft: "0px",
      paddingRight: "0px"

    },
    to: {
      right: "0px",
      width: "100%",
      paddingLeft: "10px",
      paddingRight: "40px"

    }
  },
  viewMobileInputSearch: {
    animationName: '$openInputSearch',
    animationDuration: "0.75s",
    width: "100%",
    right: "0px",
    paddingLeft: "10px",
    paddingRight: "55px"
  },


  "@keyframes closeInputSearch": {
    from: {
      right: "0px",
      width: "100%",

    },
    to: {
      right: "34px",
      width: "0%",

    }
  },
  hideMobileInputSearch: {
    animationName: '$closeInputSearch',
    animationDuration: "0.75s",
    width: "00%",
    right: "34px"
  },

  mainNav: {
    width: '100%',
    maxWidth: '1920px',
    margin: '0 auto',
  },
  '@media (max-width: 768px)': {
    mainNav: {
      // padding: '8px 10px',
      // paddingRight: "0px"
      display: "none"
    },
    mobileNav: {
      display: "flex",
      borderBottom: "2px solid #9c9c9c8c"

    },
    freeDeleviery: {
      margin: "0px",
      fontSize: "14px"
      // padding: "5px 5px"
    },
    closeIcon: {
      right: "1em"
    },
    toasts: {
      fontSize: '13px',
    },
  },




  '@media (max-width : 400px)': {
    toasts: {
      fontSize: '11px',
    },
  },

  '@media (max-width : 340px)': {
    toasts: {
      fontSize: '10px',
      fontWeight: 600,
    },
  },
  '@media (max-width: 750px)': {
    mainNav: {
      justifyContent: "space-between"
    },
    bottomNav: {
      display: "flex"
    },
    devSearch: {
      margin: "0px !important",
      paddingInlineEnd: "10px"
    }
  },

  web: {
    display: "inherit",
    '@media (max-width: 750px)': {
      display: "none",
    }
  },
  mobile: {
    display: "none",
    '@media (max-width: 750px)': {
      display: "inherit",
    }
  },
  iconLink: {
    color: '#fff',
    position: 'relative',
    '&:hover': {
      textDecoration: 'none',
      color: '#eee',
    },
  },
  badge: {
    backgroundColor: 'tomato',
    marginRight: '5px',
    position: 'absolute',
    right: '-22px',
    top: '-10px',
    color: "white"
  },
  logoutBtn: {
    background: 'none',
    border: 'none',
  },
  devSearch: {
    margin: "0px auto",
    position: "relative",
  },

  inputSearch: {
    border: "none",
    color: "white",
    backgroundColor: "black",
    float: "right",
    width: "500px",
    borderBottom: "1px solid #ffffff",
    height: "38px",
    margin: "5px 0px",
    padding: "0px 10px",
    fontSize: "15px",
    paddingLeft: "30px",
    '&::placeholder': {
      color: "white",
    },
    '@media (max-width: 965px)': {
      width: "400px"
    },
    '@media (max-width: 855px)': {
      width: "300px"
    },
    '@media (max-width: 520px)': {
      width: "100%"
    }
  },
  inputSearchIcon: {
    position: "absolute",
    top: "12px",
    color: "#bbbbbb",
    fontSize: "25px",
    left: "3px"
  },
  navBar: {
    margin: "0px 5px",
    padding: "7px 19px !important",
    fontSize: "15px",
    fontWeight: "500"
  },
  navBarBubble: {
    borderRadius: "18px",
    background: "#522583",
  },
  navDropdown: {
    colore: "red",
    "& .nav-link": {
      padding: "0px !important"
    }
  },
  avatarBox: {
    width: '24px',
    marginInlineEnd: "5px",
    height: '24px',
    marginLeft: 'auto',
  },
  avatar: {
    width: '100%',
    height: '100%',
    objectFit: "cover",
  },
  genderNav: {
    backgroundColor: "#f4f4f4",
    display: "flex",
    padding: "0px 200px"
  },
  '@media screen and (max-width: 760px)': {
    nav: {
      display: "none"
    },


    genderNav: {
      padding: "0px 20px"
    },
    mobileCategory: {
      marginBottom: "0px",
      display: "flex !important",
    }
  },
  '@media screen and (max-width : 360px)': {
    navBarBubble: {
      fontSize: '13px',
    },
  },
  genderText: {
    width: "fit-content",
    padding: "10px 5px",
    fontSize: "14px",
    fontWeight: "500",
    margin: "0px 25px"
  },
  genderActive: {
    color: "#522583 !important",
    padding: "0px",
    fontSize: "23px"
  },
  circleGenderActive: {
    width: "7px",
    borderRadius: "50%",
    height: "7px",
    backgroundColor: "#522583",
    margin: "0px auto",
    position: "absolute",
    bottom: "4px",
    left: "calc(50% - 5px)"
  },
  tagFilter: {
    display: "block",
    color: "#212529",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#522583",
      textDecoration: "none",
      color: "white"
    },
    '&:hover $tagText': {
      color: "white !important",
    }
  },
  offerTagFilter: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  tagActive: {
    // borderBottom: "2px solid"
    color: "#522583 !important"
  },
  breadCrumb: {
    backgroundColor: "#f4f4f4",
    "& ul": {
      marginBottom: "0px",
      display: "flex",
      padding: "2px 1rem",
      "& svg": {
        fontSize: "20px",
        color: "#522583",
        paddingBottom: "3px"
      },
      "& li": {
        color: "gray"
      }
    }

  },
  mobileCategoryDevText: {
    color: "#4b4948 !important"
  },
  mobileCategoryDevTextActive: {
    color: "white !important",
    fontWeight: "500"
  },
  mobileCategoryDev: {
    padding: "3px 10px",
    margin: "0px 5px",
    borderRadius: "17px",
    border: "1px solid #522583",
    whiteSpace: "nowrap"
  },
  mobileCategoryDevActive: {
    backgroundColor: " #522583",
    marginLeft: '15px',
  },
  mobileCategory: {
    display: "none",
    flexDirection: "row",
    overflow: "auto",
    marginTop: "10px",
    "&::-webkit-scrollbar": {
      width: "0px !important"
    }
  },
  "@keyframes openSideBar": {
    from: {
      opacity: "0px",
    },
    to: {
      opacity: "1px",
    }
  },
  "@keyframes closeSideBar": {
    from: {
      opacity: "1px",
    },
    to: {
      opacity: "0px",
    }
  },
  sideBar: {
    display: "none",
    backgroundColor: "#00000042",
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0px",
    zIndex: "2"
  },
  viewSideBar: {
    display: "block",
    animationName: '$openSideBar',
    animationDuration: "1s"

  },

  "@keyframes openMainSideBar": {
    from: {
      marginLeft: "-250px",
    },
    to: {
      marginLeft: "0px",
    }
  },
  mainSideBar: {
    // backgroundColor: "red",
    transition: "all 1.25s",
    maxWidth: "250px",
    marginLeft: "-250px",
    width: "80%",
    height: "100%",
    position: "fixed",
    backgroundSize: "cover",
    overflow: "auto",
    top: "0px",
    backgroundImage: "url(img/sideMenuBG.png)",
    zIndex: "11",
    "&::-webkit-scrollbar": {
      width: "6px"
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1"
    },
    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#585858",
      borderRadius: "5px"
    },
    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555"
    }

  },
  "@keyframes closeMainSideBar": {
    from: {
      marginLeft: "0px",
    },
    to: {
      marginLeft: "-250px",
    }
  },
  viewMainSideBar: {
    marginLeft: "0px",
    animationName: '$openMainSideBar',
    animationDuration: "1s"
  },
  hideMainSideBar: {
    animationName: '$closeMainSideBar',
    animationDuration: "1s",
  },
  userInfo: {
    marginTop: "40px",
    textAlign: "center"
  },
  imgProfile: {
    backgroundPosition: "center",
    borderRadius: "50px",
    margin: "0px auto"
  },
  username: {
    color: "white !important"
  },
  businessName: {
    color: "white !important",
    border: "1px solid white",
    borderRadius: "5px",
    width: "fit-content",
    padding: "0px 5px",
    margin: "10px auto",
    fontSize: "11px"
  },
  spreaterSideBar: {
    width: "100%",
    height: "2px",
    backgroundColor: "#0000001F",
    margin: "10px 0px"
  },
  itemSideBar: {
    margin: "0px 10px",
    display: "flex"
  },
  textItemSideBar: {
    marginLeft: "10px",
    display: "flex",
    "&:hover": {
      textDecoration: "none",
    }
  },
  imageTextItemSideBar: {
    marginTop: "5px",
    marginRight: "5px"
  },
  titleTextItemSideBar: {
    color: "white !important",
    cursor: 'pointer',
    fontSize: "13px",
  },
  iconTextItemSideBar: {
    color: "white",
    fontSize: "20px",
    margin: "0px 10px",
    "&:hover": {
      color: "white",
    }
  },
  subcategoryText: {
    fontSize: "14px",
    paddingBottom: "5px",
    lineHeight: "27px",
    cursor: 'pointer',
  },
  navProducts: {
    width: "100%",
  }
});

export default Navbar;
